import { h } from 'preact';
import * as BaseComp from 'components/bolt/countdown/countdown.js';
import { accessNested, joinClasses } from 'utils/utils';
import s from 'components/bolt/countdown/countdown.sss';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default class Countdown extends BaseComp.default {

	startTimer() {
		clearInterval(this.timer);
		this.counting = true;
		this.updateTime();
		this.timer = setInterval(this.updateTime, this.props.showMilliseconds ? 1 : 1000);
		this.setState({ counting: true });
	}

	updateTime() {
		if (!this.target) {
			return this.stopTimer();
		}

		let diff = Math.max(this.target - Date.now(), 0);
		const milliseconds = Math.floor((diff % 1000));
		const seconds = Math.floor((diff / SECOND) % 60);
		const minutes = Math.floor((diff / MINUTE) % 60);
		const hours = Math.floor((diff / HOUR) % 24);
		const days = Math.floor(diff / DAY);

		if (!diff) {
			this.stopTimer();
		}

		this.setState({
			remaining: { days, hours, minutes, seconds, milliseconds }
		});
	}

	setZeroes(value, places) {
		for (let i = 0; i < places - value.toString().split('').length; i++) {
			value = `0${value}`;
		}
		return value;
	}

	renderValue(value, copy, defaultLabel) {
		const label = accessNested(this.props, ['appData', 'copy', 'baseCopy', '$DATETIME_LOCALE', copy], defaultLabel);
		if (value && defaultLabel === 'Seconds') {
			const splitValue = value.toFixed(3).split('.');
			const milliseconds = this.setZeroes(splitValue[1], 3);
			const seconds = this.setZeroes(splitValue[0], 2);
			value = this.props.showMilliseconds ? `${seconds}.${milliseconds}` : seconds;
		} else if (defaultLabel !== 'Days' || value <= 99) {
			value = ('0' + value).slice(-2);
		}

		return (
			<div class={joinClasses(
				s.denomination, 
				typeof value === 'number' && s.wide, 
				(defaultLabel === 'Seconds' && this.props.showMilliseconds) && s.milliseconds)}
			>
				<div class={joinClasses(s.value, 'h1', (defaultLabel === 'Seconds' && this.props.showMilliseconds) && s.milliseconds)}>{value}</div>
				<div class={s.label}>{label}</div>
			</div>
		);
	}

	render({ annotation, hidden, visible, position, headerHeight, showMilliseconds }, { remaining, counting }) {
		const { days, hours, minutes, seconds, milliseconds } = remaining;
		const containerStyle = {
			paddingTop: position === 'top' && `${headerHeight + 24}px`
		};

		return (
			<div
				style={containerStyle}
				class={joinClasses(s.wrapper, !counting && s.remove, hidden && s.hide, visible && s.visible)}
			>
				{annotation && <div class={joinClasses(s.annotation, 'mediumB')}>{annotation}</div>}
				<div class={s.countdown}>
					{this.renderValue(days, '$LABEL_DAYS', 'Days')}
					{this.renderValue(hours, '$LABEL_HOURS', 'Hours')}
					{this.renderValue(minutes, '$LABEL_MINUTES', 'Minutes')}
					{!showMilliseconds && this.renderValue(seconds, '$LABEL_SECONDS', 'Seconds')}
					{showMilliseconds && this.renderValue(seconds + (milliseconds / 1000), '$LABEL_SECONDS', 'Seconds')}
				</div>
			</div>
		);
	}
}